/**
 * 供应商 表单配置处理
 * @author zjs
 * @time 2017-12-12
 */
export default {
    data () {
        return {
            formConfig: [{
                name: "供应商名称",
                type: "ElInput",
                field: "provider_name"
            }, {
                name: "供应商编码",
                type: "ElInput",
                field: "provider_code"
            }, {
                name: "联系人姓名",
                type: "ElInput",
                field: "name"
            }, {
                name: "联系方式",
                type: "ElInput",
                field: "tel"
            }, {
                name: "电子邮件",
                type: "ElInput",
                field: "email"
            }, {
                name: "内外部标识",
                type: "LySelect",
                json: {
                    all: false,
                    data: [{
                        value: '1',
                        disabled: true,
                        label: '集团外部2'
                    }, {
                        value: '0',
                        disabled: true,
                        label: '集团内部'
                    }]
                },
                field: "neiwaibubs"
            }]
        }
    }
}